const mediaQuery = window.matchMedia("(min-width: 1024px)");

const selectors = {
  content: "[data-content]",
  contentContainer: "[data-content-container]",
  scrollTo: "[data-scroll-to]",
  scrollToEl: (id) => `[data-scroll-id="${id}"]`,
  button: "[data-toggle-button]",
  wrap: "[data-toggle-wrap]",
  body: "[data-toggle-body]",
  open: "[data-toggle-open]",
  close: "[data-toggle-close]",
};

const regexSpecialCharacters = /[.*+?^${}()|[\]\\]/g;

function escapeRegExp(value) {
  return value.replace(regexSpecialCharacters, "\\$&");
}

function getTocAbbreviations(content) {
  return (content.dataset.tocAbbreviations || "")
    .split(",")
    .map(abbreviation => abbreviation.trim())
    .filter(Boolean);
}

function escapeHtml(value) {
  const element = document.createElement("div");
  element.textContent = value;
  return element.innerHTML;
}

function formatTocTitle(title, abbreviations) {
  return abbreviations.reduce((formattedTitle, abbreviation) => {
    const abbreviationPattern = new RegExp(`\\b${escapeRegExp(abbreviation.toLowerCase())}\\b`, "gi");
    return formattedTitle.replace(abbreviationPattern, abbreviation.toUpperCase());
  }, title.toLowerCase());
}

function renderTocTitle(title, abbreviations) {
  return escapeHtml(formatTocTitle(title, abbreviations));
}

renderContentListTable();

function renderContentListTable() {
  const content = document.querySelector(selectors.content);

  if (!content) return;
  const contentContainer = content.querySelector(selectors.content);
  const titles = Array.from(content.querySelectorAll("h2, h3"));
  const tocAbbreviations = getTocAbbreviations(content);

  if (!titles) return;

  const contentListBody = document.createElement("div"),
    contentList = document.createElement("div");
  const contentListWrapper = document.createElement("div");
  contentList.append(contentListWrapper);
  contentListWrapper.classList.add("table-of-contents__wrapper");
  contentListBody.setAttribute("data-toggle-body", "");
  contentListBody.classList.add("table-of-contents__body");
  contentListBody.classList.add("active");
  contentList.classList.add("table-of-contents");
  contentList.classList.add("active");
  contentList.setAttribute("data-toggle-wrap", "");
  contentList.setAttribute("data-content-list", "");
  const contentListHeader = document.createElement("header");
  contentListHeader.setAttribute("data-content-header", "");
  contentListHeader.classList.add("table-of-contents__header");
  contentListWrapper.append(contentListHeader);
  contentListHeader.innerHTML = `<h2>Table of contents</h2>
        <button data-toggle-hide="Hide" data-toggle-open="Open" data-toggle-button class="button button--transparent button--small active">
            <span>Hide</span>    
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
              <rect width="40" height="40.0002" rx="20" fill="#D6001F"/>
              <path d="M17.4023 19.5576C17.5785 19.6666 17.735 19.7692 17.9047 19.8782L17.9047 19.8846C20.3183 21.4939 22.3536 23.488 23.9844 25.8603L23.991 25.8667C24.1018 26.027 24.2127 26.1873 24.3171 26.354C24.3236 26.354 24.3236 26.354 24.3236 26.3669C24.4345 26.5015 24.552 26.6361 24.6889 26.7644C26.3589 28.4122 29.0726 28.4122 30.7426 26.7644C32.4191 25.123 32.4191 22.4557 30.7426 20.8143C30.6121 20.6796 30.4752 20.5642 30.3382 20.4552C30.3316 20.4552 30.3316 20.4552 30.3251 20.4488C30.1555 20.3398 29.9924 20.2372 29.8293 20.1283L29.8228 20.1218C28.1202 18.9869 26.6068 17.6597 25.2956 16.1401C24.7411 15.5054 24.2258 14.8449 23.7431 14.1461L23.7431 14.1397C23.6257 13.9794 23.5213 13.8191 23.4104 13.6524C23.2995 13.5113 23.1755 13.3703 23.0451 13.242C21.5838 11.8058 19.3333 11.6199 17.6698 12.6906C17.6698 12.6906 17.6633 12.697 17.6568 12.697C17.4219 12.8573 17.1936 13.0369 16.9848 13.242C15.3084 14.8834 15.3084 17.5507 16.9848 19.1985C17.1153 19.3268 17.2588 19.4486 17.4023 19.5576ZM26.1893 22.289C27.0374 21.4619 28.4007 21.4619 29.2423 22.289C30.0838 23.1161 30.0838 24.4562 29.2423 25.2897C28.4007 26.1168 27.0374 26.1168 26.1893 25.2897C25.3478 24.4626 25.3478 23.1161 26.1893 22.289ZM18.4852 14.7167C19.3333 13.8896 20.6966 13.8896 21.5382 14.7167C22.3797 15.5438 22.3862 16.8903 21.5382 17.7174C20.6966 18.551 19.3267 18.5445 18.4852 17.7174C17.6437 16.8903 17.6437 15.5503 18.4852 14.7167Z" fill="white"/>
              <path d="M22.5977 19.5517C22.4215 19.6607 22.265 19.7633 22.0953 19.8723L22.0953 19.8787C19.6817 21.4881 17.6464 23.4821 16.0156 25.8545L16.009 25.8609C15.8982 26.0212 15.7873 26.1814 15.6829 26.3482C15.6764 26.3482 15.6764 26.3482 15.6764 26.361C15.5655 26.4957 15.448 26.6303 15.3111 26.7585C13.6411 28.4063 10.9274 28.4063 9.25738 26.7585C7.58087 25.1171 7.58087 22.4498 9.25738 20.8084C9.38786 20.6738 9.52482 20.5584 9.66183 20.4494C9.66836 20.4494 9.66836 20.4494 9.67488 20.443C9.8445 20.3339 10.0076 20.2314 10.1707 20.1224L10.1772 20.116C11.8798 18.9811 13.3932 17.6538 14.7044 16.1343C15.2589 15.4995 15.7742 14.8391 16.2569 14.1402L16.2569 14.1338C16.3743 13.9735 16.4787 13.8132 16.5896 13.6465C16.7005 13.5055 16.8245 13.3644 16.9549 13.2362C18.4162 11.7999 20.6667 11.614 22.3302 12.6848C22.3302 12.6848 22.3367 12.6912 22.3432 12.6912C22.5781 12.8515 22.8064 13.031 23.0152 13.2362C24.6916 14.8776 24.6916 17.5449 23.0152 19.1927C22.8847 19.3209 22.7412 19.4427 22.5977 19.5517ZM13.8107 22.2831C12.9626 21.456 11.5993 21.456 10.7577 22.2831C9.91625 23.1102 9.91625 24.4503 10.7577 25.2838C11.5993 26.1109 12.9626 26.1109 13.8107 25.2838C14.6522 24.4567 14.6522 23.1102 13.8107 22.2831ZM21.5148 14.7109C20.6667 13.8837 19.3034 13.8837 18.4618 14.7109C17.6203 15.538 17.6138 16.8844 18.4618 17.7116C19.3034 18.5451 20.6733 18.5387 21.5148 17.7116C22.3563 16.8844 22.3563 15.5444 21.5148 14.7109Z" fill="white"/>
              </svg>  
        </button>`;

  let firstIndex = titles.findIndex(el => el.tagName == "H2");
  if (firstIndex > -1) {
    var html = "<ul class=\"table-of-contents__list\">";
    for (var i = firstIndex + 1; i <= titles.length - 1; i++) {
      if (titles[i].tagName == "H2") {
        titles[firstIndex].id = "heading-" + firstIndex;
        let temporary = titles.slice(firstIndex, i);
        html += `<li class="table-of-contents__list-item"><a href="#heading-${firstIndex}">${renderTocTitle(titles[firstIndex].innerText, tocAbbreviations)}</a></li>`;
        firstIndex = i;
      }
      if (i === (titles.length - 1) && firstIndex > -1) {
        titles[firstIndex].id = "heading-" + firstIndex;
        const li = document.createElement("li");
        let temporary = titles.slice(firstIndex, titles.length);
        html += `<li class="table-of-contents__list-item"><a href="#heading-${firstIndex}">${renderTocTitle(titles[firstIndex].innerText, tocAbbreviations)}</a></li>`;
      }
    }
    html += "</ul>";
    contentListBody.innerHTML = html;
    contentListWrapper.appendChild(contentListBody);

    contentContainer ? contentContainer.append(contentList) : content.prepend(contentList);
  }
  document.addEventListener("click", event => {
    const { target } = event;

    if (target.matches(selectors.scrollTo)) {
      event.preventDefault();
      const id = target.getAttribute("data-scroll-to");
      const scrollToEl = document.querySelector(selectors.scrollToEl(id));
      const offset = window.innerWidth < 1450 ? contentListHeader.offsetHeight + 250 : 0;
      window.scrollTo({
        top: scrollToEl.offsetTop - offset,
        behavior: "smooth",
      });
    }
  });

  if (mediaQuery.matches) {

    // Intersection Observer for active state tracking
    const observerOptions = {
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0
    };

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          const tocLinks = contentListBody.querySelectorAll('.table-of-contents__list-item');
          tocLinks.forEach(item => {
            const link = item.querySelector('a');
            if (link && link.getAttribute('href') === `#${id}`) {
              item.classList.add('active');
            } else {
              item.classList.remove('active');
            }
          });
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    titles.forEach(title => {
      if (title.id) {
        observer.observe(title);
      }
    });

    var lastScrollTop = 0,
      scrollDirection;
    window.addEventListener("scroll", function(event) {
      var st = this.scrollY;
      if (st > lastScrollTop) {
        scrollDirection = "down";
      } else {
        scrollDirection = "up";
      }

      if (contentList.getBoundingClientRect().bottom < -175) {
        if (!contentList.classList.contains("sticky")) {
          contentList.style.height = contentList.offsetHeight + "px";
        }
        contentList.classList.add("sticky");
      } else if (contentList.getBoundingClientRect().bottom > -175) {

        contentList.classList.remove("sticky");
        contentList.style.height = "auto";

      }
      if (content.getBoundingClientRect().bottom < contentListWrapper.getBoundingClientRect().bottom && contentList.classList.contains("sticky") && scrollDirection == "down") {
        content.style.position = "relative";
        contentListWrapper.style.bottom = 0;
        contentListWrapper.style.top = "auto";
        contentListWrapper.style.position = "absolute";
      } else if (contentListWrapper.getBoundingClientRect().top >= 120 && contentList.classList.contains("sticky") && scrollDirection == "up") {
        content.style.position = "";
        contentListWrapper.style.bottom = "";
        contentListWrapper.style.top = "";
        contentListWrapper.style.position = "";
      }
      lastScrollTop = st <= 0 ? 0 : st;
    });

  }
  window.addEventListener("resize", event => {
    if (window.innerWidth < 1400) {
      contentList.style.height = "";
      contentList.classList.remove("sticky");
    }
  });
}

function renderInnerElement(temporary, i) {
  if (!temporary.length) return ``;
  const subtitles = temporary.filter(el => el.tagName === "H3");
  if (!subtitles.length) return ``;
  return `<div class="table-of-contents__dropdown"><ul> ${subtitles.map((el, index) => {
    el.setAttribute("data-scroll-id", `${i}-${index}`);
    return `<li><a data-scroll-to="${i}-${index}" href="#">${el.innerText}</a></li>`;
  })}</ul></div>`;
}

const toggleElement = (element) => {
  const open = element.getAttribute("data-toggle-open");
  const close = element.getAttribute("data-toggle-hide");
  const wrap = element.closest(selectors.wrap);
  const body = wrap ? wrap.querySelector(selectors.body) : undefined;
  const text = element.querySelector("span");

  element.classList.toggle("active");
  
  if (wrap) {
    wrap.classList.toggle("active");
    wrap.style.height = "auto";
  }

  if (body) {
    body.classList.toggle("active");
  }

  if (!open || !close || !text) return;
  element.classList.contains("active") ? text.innerText = close : text.innerText = open;
};

document.addEventListener("click", (event) => {
  const target = event.target;
  if (target.matches(`${selectors.button}, ${selectors.button} *`)) {
    event.preventDefault();
    const element = target.matches(selectors.button) ? target : target.closest(selectors.button);
    toggleElement(element);
  }
});

// This code below fixes an issue where a heading is hidden by a sticky header, and it enables smooth scrolling to display the heading.
let links = document.querySelectorAll(".table-of-contents__list a");

links.forEach(function(link) {
  link.addEventListener("click", function(e) {
    e.preventDefault(); // Prevent the default link behavior

    let href = this.getAttribute("href"); // Get the target section ID
    let target = document.querySelector(href); // Find the target section

    if (target) {
      // Calculate position and scroll
      const scrollToTarget = () => {
        const targetPosition = target.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = targetPosition - 140;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
        
        // Verify position after scroll completes (accounts for lazy-loaded images)
        setTimeout(() => {
          const currentTargetPosition = target.getBoundingClientRect().top;
          // If target is not in the correct position (should be ~140px from top), adjust
          if (Math.abs(currentTargetPosition - 140) > 10) {
            const correctedPosition = target.getBoundingClientRect().top + window.scrollY - 140;
            window.scrollTo({
              top: correctedPosition,
              behavior: "smooth",
            });
          }
        }, 800); // Wait for smooth scroll to complete
      };
      
      requestAnimationFrame(scrollToTarget);
    }
  });
});

// Sticky Share Icons in Single Blog
let hasSeenFooter = false;

function isElementInViewport(el, offset = 0) {
  var rect = el.getBoundingClientRect();
  return rect.top - offset <= window.innerHeight && rect.bottom >= 0;
}

function checkFooterVisibility() {
  const footer = document.querySelector(".insight-item__categories");

  if (isElementInViewport(footer, -280) && !hasSeenFooter) {
    document.querySelector(".share-list").classList.add("-absolute");
    hasSeenFooter = true; // Set the variable to true to indicate the footer has been seen
  } else if (!isElementInViewport(footer, -280) && hasSeenFooter) {
    document.querySelector(".share-list").classList.remove("-absolute");
    hasSeenFooter = false; // Set the variable to false to indicate the footer is no longer in the viewport
  }
}

// window.addEventListener('scroll', checkFooterVisibility);
// window.addEventListener('resize', checkFooterVisibility);

// // Call the function initially when the page loads
// document.addEventListener('DOMContentLoaded', checkFooterVisibility);

